export const TreeStudiesObj = [
    {
      Header: "Holy Rosary English Medium High School, Kundapura.",
      Subtitle: "10th Standard",
      CalendarYear: "2012-2013",
    },
    {
      Header: "Bhandarkar's Pre-University College, Kundapura.",
      Subtitle: "12th Standard(PCMC)",
      CalendarYear: "2014-2015",
    },
    {
      Header: "Dr. Ambedkar Institute of Technology, Bengaluru.",
      Subtitle: "Information Science & Engineering",
      CalendarYear: "2015-2019",
    }
];

export const TreeWorkObj = [
  {
    Header: "Systems Engineer Trainee",
    Subtitle: "Infosys Limited",
    CalendarYear: "2019-2020",
  },
  {
    Header: "Systems Engineer",
    Subtitle: "Infosys Limited",
    CalendarYear: "2020-2021",
  },
  {
    Header: "Senior Systems Engineer",
    Subtitle: "Infosys Limited",
    CalendarYear: "2021-2022",
  },
  {
    Header: "Technology Analyst",
    Subtitle: "Infosys Limited",
    CalendarYear: "2022-Present",
  },
];
